import React from 'react';
import PageList from '../../../components/PageListAPI'
import { getCarRental, deleteCarRental } from '../../../api/doc'
import { useCan } from '../../../hooks/useCan';
import { SLUGS } from '../../../enum/permissions.enum';

export default function CarRental(props) {
  const can = useCan();
  return (
    <div className='App-paper'>
      <PageList
        name='carRental'
        title='Документы аренды спец. техники'
        columns={[
          { id: 'model', name: 'Марка,модель авто', },
          { id: 'licensePlate', name: 'Гос. знак' },
          { id: 'transportationDetails', name: 'Сведения о перевозке' },
          { id: 'companyShortName', name: 'Организация' },
          {
            id: 'driver', name: 'Водитель', type: 'component',
            component: ({ obj }) => <div>
              {obj.driverSurname}  {obj.driverName[0]}.  {obj.driverPatronymic[0]}.
            </div>
          },
          { id: 'dateStart', name: 'Дата начала', type: 'date' },
          { id: 'dateEnd', name: 'Дата окончания', type: 'date' },
          { id: 'hours', name: 'Часы' },
          { id: 'price', name: 'Стоимость за час' },
        ]}
        createItem={can(SLUGS.DOC.CAR_RENTAL.MANAGE)}
        deleteItem={can(SLUGS.DOC.CAR_RENTAL.MANAGE)}
        loadAPI={{
          querty: {
            idProject: props.match.params.idProject
          },
          request: getCarRental,
        }}
        deleteAPI={deleteCarRental}
        click={false}
        {...props}
      />
    </div>
  )
};


